<template>
  <div>
    <ejs-grid :dataSource="roleData" ref="roleGrid" :dataBound='dataBound' height="400">
      <e-columns>
        <e-column type="checkbox" width="50" textAlign="center"></e-column>
        <e-column field="roleId" :visible="false" :isPrimaryKey="true"></e-column>
        <e-column field="roleName" :headerText="$t('Security.Role.name')" width="120" textAlign="Center"></e-column>
        <e-column field="createTime" :headerText="$t('Security.Role.createTime')" :format="dateFormat" width="120" textAlign="Center"></e-column>
        <e-column field="creator" :headerText="$t('Security.Role.creator')" width="120" textAlign="Center"></e-column>
        <e-column field="description" :headerText="$t('Security.User.desc')" width="120" textAlign="Center"></e-column>
      </e-columns>
    </ejs-grid>
  </div>
</template>
<script>
export default {
  name: 'AccountRole',
  data() {
    return {
      selectedRoleIds: [],
      roleData: [],
      selectIndexes: [],
      dateFormat: {
        type: 'date', format: 'yyyy/MM/dd HH:mm:ss'
      },
    };
  },
  mounted() {
  },
  methods: {
    init(selectedRoleIds) {
      this.selectedRoleIds = selectedRoleIds;
    },
    getRoleList() {
      const url = '/lte/ems/role/findList';
      const params = { params: {

      } };
      const That = this;
      this.axios.get(url, params).then(response => {
        const result = response.data;
        result.forEach((item, index) => {
          item.createTime = new Date(item.createTime);
          if (That.selectedRoleIds.indexOf(item.roleId) > -1) {
            this.selectIndexes.push(index);
          }
        });
        That.roleData = result;
      });
    },
    dataBound() {
      this.$refs.roleGrid.selectRows(this.selectIndexes, false);
    },
    getSelectRole() {
      return this.$refs.roleGrid.getSelectedRecords();
    }
  }
};
</script>
